import awsdk from 'awsdk';
import { TestMyComputerConfiguration, Wizard } from 'lib/amwell/sdk/types';
import BaseService from './BaseService';
import AwsdkError from '../errors/AwsdkError';
import { errors } from '../constants';

export default class TestMyComputerService extends BaseService {
  getTestMyComputerWizard(config: TestMyComputerConfiguration): Wizard {
    const key = this.getTestMyComputerWizard.name;
    if (!awsdk.utils.WebRTCHelper.isWebRTCSupported()) {
      throw new AwsdkError(key, errors.WEBRTC_SUPPORT);
    }
    return this.sdk.testMyComputerService.getTestMyComputerWizard(config);
  }
}
